module.exports = __webpack_public_path__ + "static/media/audit-trall-icon.8cd53e06.svg";